import { subCategorySchema } from "@/schema/console/assessments/create/SubCategory";
import { z } from "zod";

export const categorySchema = z.object({
  id: z.string(),
  content: z.string(),
  isEdit: z.boolean(),
  selectedSubCategory: z.string(),
  subcategories: z
    .array(subCategorySchema)
    .min(1, "Please add at least one sub category."),
});

export type Category = z.infer<typeof categorySchema>;
